<template>
  <div>
    <div class="calculator-submenu">
      <div :class="{'calculator-submenu-item':true,'selected':$route.query.submenu==='calculate'}" @click="gotoSubmenu('calculate',$event)">
        <div class="submenu-text">
          {{ $t('calculator.submenu.calculate') }}
        </div>
      </div>
      <div :class="{'calculator-submenu-item':true,'selected':$route.query.submenu==='saved_list'}" @click="gotoSubmenu('saved_list',$event)">
        <div class="submenu-text">
          {{ $t('calculator.submenu.saved_list') }}
        </div>
      </div>
      <div :class="{'calculator-submenu-item':true,'selected':$route.query.submenu==='shared_list'}" @click="gotoSubmenu('shared_list',$event)">
        <div class="submenu-text">
          {{ $t('calculator.submenu.shared_list') }}
        </div>
      </div>
      <div class="clear" />
    </div>
    <div class="calculator-contents" :submenu="$route.query.submenu">
      <div v-if="$route.query.submenu === 'calculate'">
        <calculator-detail key="new-calc" :init-calc="newCalc" @calc-updated="onNewCalcUpdated" />
      </div>
      <div v-if="$route.query.submenu === 'saved_list'">
        <saved-calc-list
          v-if="!$route.query.savedId"
          :init-conditions="savedConditions"
          :init-data="savedCalcInitData"
          @select-calc="selectSavedCalc"
          @condition-changed="onSavedConditionChanged"
          @scroll-and-data="onSavedCalcScrollAndDataChanged"
        />
        <calculator-detail v-else :id="$route.query.savedId" :key="'saved-calc-' + $route.query.savedId" :init-show-selected="true" @calc-deleted="onSavedCalcDeleted" />
      </div>
      <div v-if="$route.query.submenu === 'shared_list'">
        <shared-calc-list
          v-if="!$route.query.sharedId"
          :init-conditions="sharedConditions"
          :init-data="sharedCalcInitData"
          @select-calc="selectSharedCalc"
          @condition-changed="onSharedConditionChanged"
          @scroll-and-data="onSharedCalcScrollAndDataChanged"
        />
        <calculator-detail
          v-else
          :id="$route.query.sharedId"
          :key="'shared-calc-' + $route.query.sharedId"
          :shared="true"
          :init-show-selected="true"
          @copy-calc="onCopyCalc"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SharedCalcList from '../composites/SharedCalcList'
import SavedCalcList from '../composites/SavedCalcList'
export default {
  components: { SavedCalcList, SharedCalcList },
  data() {
    return {
      newCalc: undefined,
      reasonOptions: [],
      sexdstnCodes: [],
      ageCodes: [],
      sharedConditions: undefined,
      savedConditions: undefined,
      sharedCalcInitData: undefined,
      savedCalcInitData: undefined
    }
  },
  watch: {
    '$route.query.submenu': {
      handler(newVal, oldVal) {
        this.$forceUpdate()
        $('body').attr('calculator-submenu', newVal)
        if (newVal === 'calculate') {
          if (!window._processingDataCount) {
            window._processingDataCount = 0
          }
          window._processingDataCount++
        }
        if (newVal === 'saved_list' && this.$route.query.savedId) {
          if (!window._processingDataCount) {
            window._processingDataCount = 0
          }
          window._processingDataCount++
        }
      },
      immediate: true
    },
    '$route.query.savedId': {
      handler(newVal, oldVal) {
        if (newVal) {
          $('body').attr('saved-id', newVal)
          if (this.$route.query.submenu === 'saved_list') {
            if (!window._processingDataCount) {
              window._processingDataCount = 0
            }
            window._processingDataCount++
          }
        } else {
          $('body').removeAttr('saved-id')
        }
      }
    },
    '$route.query.sharedId': {
      handler(newVal, oldVal) {
        if (newVal) {
          $('body').attr('shared-id', newVal)
        } else {
          $('body').removeAttr('shared-id')
        }
      }
    }
  },
  async mounted() {
    if (!this.$route.query.submenu) {
      this.gotoSubmenu('calculate', undefined, true)
    }
    this.ageCodes = await this.getCodes('age')
    this.sexdstnCodes = await this.getCodes('sex_distinction')
    this.resetReasonCodes = await this.getCodes('reset_reason')
    for (let i = 0; i < this.resetReasonCodes.length; i++) {
      const code = this.resetReasonCodes[i]
      this.reasonOptions.push({
        value: code.codeId,
        text: this.$t('code.nm.' + code.codeId)
      })
    }
    this.$eventHub.$emit('content-loaded')
  },
  beforeDestroy() {
    $('body').removeAttr('calculator-submenu')
    $('body').removeAttr('saved-id')
    $('body').removeAttr('shared-id')
  },
  methods: {
    onSavedCalcScrollAndDataChanged(data) {
      this.savedCalcInitData = data
    },
    onSharedCalcScrollAndDataChanged(data) {
      this.sharedCalcInitData = data
    },
    onSavedCalcDeleted(calc) {
      const query = window.copyObject(this.$route.query)
      delete query.savedId
      this.$router.push({
        query: query
      })
    },
    onNewCalcUpdated(calc) {
      this.newCalc = calc
      this.$forceUpdate()
    },
    selectSavedCalc(param) {
      const e = param.e
      const calc = param.calc
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      const query = window.copyObject(this.$route.query)
      query.savedId = calc.id
      this.$router.push({
        query: query
      })
    },
    selectSharedCalc(param) {
      const e = param.e
      const calc = param.calc
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      const query = window.copyObject(this.$route.query)
      query.sharedId = calc.id
      this.$router.push({
        query: query
      })
    },
    onCopyCalc(param) {
      this.newCalc = param
      this.gotoSubmenu('calculate')
    },
    onSavedConditionChanged(param) {
      this.savedConditions = param
      this.$forceUpdate()
    },
    onSharedConditionChanged(param) {
      this.sharedConditions = param
      this.$forceUpdate()
    },
    gotoSubmenu(submenu, e, replace) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }

      if (
        this.$route.query.submenu === 'calculate' &&
        submenu &&
        submenu !== 'calculate'
      ) {
        if (window._processingDataCount && window._processingDataCount > 0) {
          if (confirm(this.$t('goods.confirm.cancel_work'))) {
            window._processingDataCount = 0
          } else {
            return
          }
        }
      }
      if (!this.$route.query || this.$route.query.submenu !== submenu) {
        let url = this.$route.path + '?submenu=' + submenu
        if (submenu === 'reset_ing') {
          url += '&mode=calendar'
        }
        if (replace) {
          this.$router.replace(url)
        } else {
          this.$router.push(url)
        }
        if (e) {
          this.vibrate(e)
        }
      } else if (
        this.$route.query.submenu === submenu &&
        submenu === 'saved_list'
      ) {
        const query = window.copyObject(this.$route.query)
        delete query.savedId
        this.$router.push({
          query: query
        })
      } else if (
        this.$route.query.submenu === submenu &&
        submenu === 'shared_list'
      ) {
        const query = window.copyObject(this.$route.query)
        delete query.sharedId
        this.$router.push({
          query: query
        })
      }
    }
  }
}
</script>

<style scoped>
.calculator-contents {
  margin-top: 3.2rem;
  background-color: #eeeeee;
}
.calculator-contents >>> label {
  margin-bottom: 0;
}
.calculator-submenu {
  padding: 0.4rem 0.5rem 0.6rem;
  position: fixed;
  width: 100vw;
  height: 3.358333333333333rem;
  top: 7.1rem;
  background: white;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
.calculator-submenu-item {
  height: 3.358333333333333rem;
  width: calc(100% / 3);
  font-size: 0.916666666666667rem;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.1;
  color: black;
  font-weight: bold;
}
.calculator-submenu-item .submenu-text {
  border-radius: 1rem;
  padding: 0.1796rem 0.3rem;
  min-width: 90%;
  text-align: center;
  line-height: unset;
  display: flex;
  align-items: center;
  justify-content: center;
}
.calculator-submenu-item.selected {
  border-bottom: 2px solid #360ea6;
  opacity: 1;
}
.calculator-contents[submenu='saved_list'],
.calculator-contents[submenu='shared_list'] {
  background: white;
}
>>> .reset-reason-select * {
  z-index: 3 !important;
}
</style>
